module.exports = "/assets/data/3ad22adcb2178005fc78fea1f18b2e82-NR1.data.json";